import { render, staticRenderFns } from "./MonitoringStatusItem.vue?vue&type=template&id=15885b5c&scoped=true&"
import script from "./MonitoringStatusItem.vue?vue&type=script&lang=js&"
export * from "./MonitoringStatusItem.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringStatusItem.vue?vue&type=style&index=0&id=15885b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15885b5c",
  null
  
)

export default component.exports